import { createFileRoute } from '@tanstack/react-router';
import { NotificationsClient } from './-components/NotificationsClient';

type NotificationsSearch = { scope?: 'circle' | 'network' | string };

export const Route = createFileRoute('/_authed/notifications/')({
  validateSearch: (raw: Record<string, unknown>): NotificationsSearch => {
    const scope = typeof raw.scope === 'string' ? raw.scope : undefined;
    return scope !== undefined ? { scope } : {};
  },
  component: NotificationsPage,
});

function NotificationsPage() {
  return <NotificationsClient />;
}
